module.exports = __webpack_public_path__ + "static/media/golem-head.48b0456c.svg";